export const REDUX_SLICE = {
  APP: 'app',
  PROJECT_API: 'projectApi',
  UPLOAD_API: 'uploadApi',
  ROLE_API: 'roleApi',
  VOTE_API: 'voteApi',
  OTC_API: 'otcApi',
  NETWORK_API: 'networkApi',
  ANALYTICS_API: 'analyticsApi',
  PROJECT_DASHBOARD_API: 'projectDashboardApi',
  PRICE_API: 'priceApi',
  MEMBER_API: 'memberApi',
} as const;
